import CryptoJS from "crypto-js";

// chatgpt
// const KEY = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTO_KEY);

// original
export const KEY = CryptoJS.enc.Utf8.parse('ED6C504C24FD3140D42E3BFE9F92E4A1');